import PropTypes from 'prop-types';
import { Navigate, useLocation } from 'react-router-dom';
// hooks
import useAuth from '../hooks/useAuth';
// routes
import { PATH_DASHBOARD, PATH_SERVICE_PRO } from '../routes/paths';

// ----------------------------------------------------------------------

GuestGuard.propTypes = {
  children: PropTypes.node
};

export default function GuestGuard({ children }) {
  const { isAuthenticated, user } = useAuth();
  const { pathname } = useLocation();

  if (isAuthenticated) {
    let redirect;
    // An authenticated visitor to /auth/register is almost always somebody who
    // just signed up, so the walkthrough is where they belong — UNLESS they
    // have already finished it. Sending a set-up homeowner who happened to open
    // the register page back through onboarding is a small thing that reads as
    // the app having lost their account.
    if (pathname === '/auth/register' && !user.completed_walkthrough) {
      redirect = <Navigate to={PATH_DASHBOARD.general.walkthrough} />;
    } else if (['Admin', 'Homeowner'].includes(user.role)) {
      redirect = (
        <Navigate to={user.completed_walkthrough ? PATH_DASHBOARD.general.app : PATH_DASHBOARD.general.walkthrough} />
      );
    } else {
      redirect = <Navigate to={PATH_SERVICE_PRO.dashboard} />;
    }
    return redirect;
  }

  return <>{children}</>;
}
